import { fetch } from "./store";
import models from "./index";
const attachRefs = (schema, model) => {
  if (!model._refs) model._refs = {};
  // console.log(model)
  const modelName = model.modelName;
  const data = model.data();
  Object.keys(schema).forEach((key) => {
    if (schema[key].ref && models[schema[key].ref]) {
      if (schema[key].oneToMany) {
        model[key] = [];
        model._refs[key] = true;
        data[key].forEach((id) => {
          fetch(schema[key].ref, id)
            .then((ref) => {
              model[key].push(ref);
              if (!ref[modelName]) ref[modelName] = model;
              ref._refs[modelName] = true;
            })
            .catch((e) => {
              console.error(e);
            });
        });
      } else {
        model[key] = null;
        model._refs[key] = true;
        fetch(schema[key].ref, data[key])
          .then((ref) => {
            model[key] = ref;
            if (schema[key].oneToOne) {
              if (!ref[modelName]) ref[modelName] = model;
              ref._refs[modelName] = true;
            } else {
              if (!ref[modelName]) ref[modelName] = [];
              ref._refs[modelName] = true;
              if (!ref[modelName].includes(model)) ref[modelName].push(model);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  });
};
export default attachRefs;
